import api from "./api";
import { API_ENDPOINTS } from "../constants";
import { ApiResponse, User, RegisterFormData } from "../types";
import {
  setAuthToken,
  setUserData,
  removeAuthToken,
  removeUserData,
} from "../utils";

interface AuthResponse {
  user: User;
  token: string;
  refreshToken: string;
}

/**
 * Login a user
 * @param credentials Login credentials
 * @returns Promise with auth response
 */


// Flag to use mock data instead of real API calls

/**
 * Register a new merchant
 * @param data Registration data
 * @returns Promise with auth response
 */
export const register = async (
  data: RegisterFormData
): Promise<AuthResponse> => {
  const response = await api.post<ApiResponse<AuthResponse>>(
    API_ENDPOINTS.REGISTER,
    data
  );

  if (response.data) {
    const { user, token, refreshToken } = response.data;

    // Store auth data
    setAuthToken(token);
    setUserData(user);
    localStorage.setItem("send_merchant_refresh_token", refreshToken);

    return response.data;
  }

  throw new Error("Registration failed");
};

/**
 * Logout the current user
 */
export const logout = async (): Promise<void> => {
  removeAuthToken();
    removeUserData();
    localStorage.removeItem("send_merchant_refresh_token");
};

/**
 * Check if the user is authenticated
 * @returns True if authenticated, false otherwise
 */
export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem("send_merchant_auth_token");
  return !!token;
};

/**
 * Get the current user data
 * @returns User data or null
 */
export const getCurrentUser = (): User | null => {
  return JSON.parse(localStorage.getItem("send_merchant_user_data") || "null");
};
